import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const painPoints = ['Te mirás al espejo y no te reconocés', 'Nada de la ropa te queda como antes', 'Estás cansada todo el tiempo', 'No tenés tiempo para entrenar', 'Probaste empezar… pero lo dejaste'];
  const objections = ['Tienen tiempo', 'No tienen hijos', 'Pueden entrenar 1 hora tranquila'];
  return <section className="py-10 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto relative" data-id="element-247">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-red-50 blur-[120px] rounded-full pointer-events-none" data-id="element-248" />

      <div className="relative z-10" data-id="element-249">
        {/* Parte 1: Dolor + Identificación */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-250">
          <span className="text-4xl mb-4 block" data-id="element-251">💔</span>
          <h2 className="font-display text-2xl md:text-4xl font-bold mb-6 leading-tight text-gray-900" data-id="element-252">
            Si sos mamá, probablemente te pasa esto:
          </h2>
        </motion.div>

        <div className="bg-white/80 border border-pink-200/50 rounded-3xl p-6 md:p-8 mb-8 shadow-sm" data-id="element-253">
          <ul className="space-y-4 max-w-xl mx-auto" data-id="element-254">
            {painPoints.map((point, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-center gap-3 text-base md:text-lg text-gray-600 font-medium" data-id="element-255">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-red-50 flex items-center justify-center" data-id="element-256">
                  <X size={14} className="text-brand-danger" data-id="element-257" />
                </div>
                <span data-id="element-258">{point}</span>
              </motion.li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-4 mb-12" data-id="element-259">
          <p className="text-lg text-gray-500 font-medium" data-id="element-260">Y lo peor…</p>
          <div className="inline-block bg-brand-card border border-pink-200 rounded-2xl p-4 md:p-6 shadow-md" data-id="element-261">
            <p className="text-xl md:text-2xl font-bold text-gray-900" data-id="element-262">
              👉 Sentís que tu cuerpo ya no vuelve más
            </p>
          </div>
        </motion.div>

        {/* Parte 2: Romper objeción */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center pt-8 border-t border-pink-200/50" data-id="element-263">
          <span className="text-4xl mb-4 block" data-id="element-264">😔</span>
          <div className="space-y-2 text-xl md:text-2xl font-bold text-gray-900 mb-6" data-id="element-265">
            <p data-id="element-266">No es falta de ganas.</p>
            <p data-id="element-267">No es falta de disciplina.</p>
          </div>

          <p className="text-lg md:text-xl text-gray-600 mb-6 font-medium" data-id="element-268">
            El problema es que todos los programas fitness están hechos para
            personas que:
          </p>

          <ul className="space-y-3 max-w-md mx-auto mb-8 text-left bg-pink-50/50 p-6 rounded-2xl border border-pink-100" data-id="element-269">
            {objections.map((obj, i) => <li key={i} className="flex items-center gap-3 text-base md:text-lg text-gray-600" data-id="element-270">
                <X size={18} className="text-brand-danger flex-shrink-0" data-id="element-271" />
                <span data-id="element-272">{obj}</span>
              </li>)}
          </ul>

          <p className="text-2xl md:text-3xl font-display font-black text-brand-accent" data-id="element-273">
            👉 Y esa NO es tu realidad
          </p>
        </motion.div>
      </div>
    </section>;
}